export enum NoiseType {
  Brown = "Brown",
  Pink = "Pink",
  White = "White",
}
